import React from 'react';
import PropTypes, { func } from 'prop-types';

import Kinostyles from '../../Util/LandingPageStylesComponent.module.css';
import { Image } from 'react-bootstrap';
const LandingPageImage = props => {
  const {
    webpImage,
    jpegImage,
    avifImage,
    landscapeImage,
    title,
    altText,
    halfSize,
    link,
  } = props;

  function getImageContent() {
    return (
      <>
        <div className="d-lg-none">
          <picture>
            {avifImage ? (
              <source
                media="(max-width: 400px)"
                type="image/avif"
                srcSet={avifImage}
              />
            ) : (
              ''
            )}
            {webpImage ? (
              <source
                media="(max-width: 400px)"
                type="image/webp"
                srcSet={webpImage}
              />
            ) : (
              ''
            )}
            <source media="(max-width: 400px)" type="image/jpeg" />

            {halfSize ? (
              <Image
                loading="lazy"
                fetchpriority="high"
                className={Kinostyles.CenterContent + ' p-4 w-100'}
                src={jpegImage}
                alt={altText}
                title={title}
              />
            ) : (
              <Image
                loading="lazy"
                fetchpriority="high"
                className="p-4 w-100"
                src={jpegImage}
                alt={altText}
                title={title}
              />
            )}
          </picture>
        </div>
        <div className="d-none d-lg-block">
          <picture>
            {avifImage ? (
              <source
                media="(max-width: 400px)"
                type="image/avif"
                srcSet={avifImage}
              />
            ) : (
              ''
            )}
            {webpImage ? (
              <source
                media="(max-width: 400px)"
                type="image/webp"
                srcSet={webpImage}
              />
            ) : (
              ''
            )}
            <source
              media="(max-width: 768px)"
              type="image/jpeg"
              srcSet={jpegImage}
            />
            {landscapeImage ? (
              <source type="image/jpeg" srcSet={landscapeImage} />
            ) : (
              ''
            )}
            {halfSize ? (
              <Image
                loading="lazy"
                fetchpriority="high"
                className={Kinostyles.CenterContent + ' p-4 w-50'}
                src={jpegImage}
                alt={altText}
                title={title}
              />
            ) : (
              <Image
                loading="lazy"
                fetchpriority="high"
                className="p-4 w-100"
                src={jpegImage}
                alt={altText}
                title={title}
              />
            )}
          </picture>
        </div>
      </>
    );
  }
  function getImageContentIncludingLink(pLink) {
    return <a href={pLink}>{getImageContent()}</a>;
  }
  return <>{link ? getImageContentIncludingLink(link) : getImageContent()}</>;
};

LandingPageImage.propTypes = {
  avifImage: PropTypes.string,
  webpImage: PropTypes.string,
  jpegImage: PropTypes.string,
  landscapeImage: PropTypes.string,
  title: PropTypes.string,
  altText: PropTypes.string,
  halfSize: PropTypes.bool,
  link: PropTypes.string,
};

export default LandingPageImage;
